/** Flux de travail société — flags appliqués (e-mail, convert, archive). */
export type CompanyWorkflow = {
  wf_email_invoice: boolean;
  wf_email_quote: boolean;
  wf_email_recurring: boolean;
  wf_stop_unpaid: boolean;
  wf_archive_paid: boolean;
  wf_quote_convert: boolean;
  wf_archive_quote: boolean;
  wf_quote_terms: boolean;
};

function asBool(v: unknown, fallback: boolean): boolean {
  if (v == null) return fallback;
  if (typeof v === "boolean") return v;
  if (typeof v === "number") return v !== 0;
  if (v === "0" || v === "false") return false;
  return Boolean(v);
}

export function workflowFromCompany(row: Partial<CompanyWorkflow> | null | undefined): CompanyWorkflow {
  return {
    wf_email_invoice: asBool(row?.wf_email_invoice, false),
    wf_email_quote: asBool(row?.wf_email_quote, false),
    wf_email_recurring: asBool(row?.wf_email_recurring, false),
    wf_stop_unpaid: asBool(row?.wf_stop_unpaid, true),
    wf_archive_paid: asBool(row?.wf_archive_paid, false),
    wf_quote_convert: asBool(row?.wf_quote_convert, false),
    wf_archive_quote: asBool(row?.wf_archive_quote, true),
    wf_quote_terms: asBool(row?.wf_quote_terms, true),
  };
}
